import React from 'react';
import Sorting from './Sorting';
import { TextField, MenuItem } from '@mui/material';
import _ from 'lodash';
import Edit from '../images/headericon/Edit.svg';
import '../css/regokas.css';
import { search } from 'react-icons-kit/icomoon/search';
import Delete from '../images/headericon/Delete.svg';
import Success from '../images/Success.svg';
import Error from '../images/Error.svg';
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    IconButton,
} from "@mui/material";
import Loader from '../components/loader';
import { connect } from 'react-redux';
import * as ActionTypes from '../actions/types';
import errorText from '../errorText';
import SearchBar from './SearchBar';
import SnackBar from '../containers/SnackBar';
import Style from 'style-it';
import { AiOutlinePlus } from 'react-icons/ai';
import { RxCross2 } from 'react-icons/rx';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';
import { Box, textTransform } from '@mui/system';
import DynamicAccordion from '../components/user-management/PermissionsAccordian';
import { modulesDataSI } from '../constant/permissions';
import { modulesDataDistributor } from '../constant/permissions';
import { is_allowed } from '../utils';


class Roles extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            topHeightModal: '0%',
            okasBoxData: [],
            confirmWindow: false,
            kk: 'asdvhj',
            phone: '',
            name: '',
            selectedPermissions: {},
            email: '',
            officelocation: '',
            error: '',
            nameerror: '',
            namess: '',
            sortedType: '',
            searchValue: '',
            actualdata: [],
            disabledvalue: '',
            classshowofmodal: false,
            successmsgmodaldata: localStorage.getItem('dataadded'),
            showmodels: '',
            searchbar: '',
            opensearch1: 0,
            loader: '',
            currentPage: 1,
            todosPerPage: 10,
            statuson: false, statustw: false, statusth: false,
            statusfo: false, statusfi: false, statussi: false,
            statusse: false, statusei: false, statusni: false,
            statuste: false,
            indianCityWithState: [],
            showError: false,
            otherlocation: '',
            snackbarActive: false,
            snackbarMessage: '',
            permissions: [],
            role_id: null,
            initial_permissions: {}

        };
    }

    confirmWindowClose = () => {
        this.props.backgroundScrollStop(!this.props.redux.globalVar.backgroundScrollStop);
        this.setState({
            confirmWindow: false
        })
    }

    onSelectChange = (operationMode, valueSelect) => {
        if (operationMode === 'rating') {
            this.setState({
                SiRating: valueSelect.value,
                errorMessage: []
            })
        }
        if (operationMode === 'relationStat') {
            this.setState({
                SiRelationStat: valueSelect.value,
                errorMessage: []
            })
        }
        if (operationMode === 'siArea') {
            this.setState({
                SiArea: valueSelect.value,
                errorMessage: [],
                officelocation: valueSelect.value,
                officelocationerror: false,
                error: false,
            })
        }
    }

    opensearch = (data) => {
        if (data == 0)
            this.setState({
                opensearch1: 1,
            });
        else
            this.setState({
                opensearch1: 0,
            });
    }

    componentWillMount() {
    }

    checkuserApi = () => {
        const token = localStorage.getItem("auth");
        const csrfToken = localStorage.getItem("csrftoken");

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`,
            'X-CSRFToken': csrfToken
        };

        fetch('/we/we/userCheckApi/', {
            method: "GET",
            headers: headers
        })
            .then(response => response.json())
            .then(data => {
                const { permissions, source, status } = data;

                if (status !== '200') {
                    localStorage.removeItem('auth');
                    window.location = "/login/session-timeout";
                    return;
                }

                this.setState({ permissions, source });
            })
            .catch(error => {
                console.error("❌ Error fetching user data:", error);
            });
    };


    componentDidMount() {
        this.getallrealdata();
        this.checkuserApi();
    }


    //------------------------------------------------ error msg function start--------------------------------------------------------
    errormsg = () => {
        setTimeout(
            function () {
                localStorage.removeItem('dataadded');
                this.setState({
                    successmsgmodaldata: '',
                    error: '',
                })
            }
                .bind(this), 3000
        );
    }


    //------------------------------------------------ error msg function end ------------------------------------------------



    handleEditIcon(details) {

        this.onopenmodel()

        this.setState({ name: details.name, role_id: details.role_id, selectedPermissions: details.permissions })

    }

    getPermissions() {
        let modulesData;
        const name = localStorage.getItem('name');

        if (name === '1') {
            modulesData = modulesDataSI;
        } else if (name === '3') {
            modulesData = modulesDataDistributor;
        } else if (name === '4') {
            const { permissions } = this.state;

            if (Array.isArray(permissions) && permissions.length > 0) {
                const modules = Object.keys(permissions[0]); // Get ["support", "inventory"]
                modulesData = modules.map((module) => ({
                    module: module,
                    actions: permissions[0][module] // ["add"], ["delete"], etc.
                }));

            } else {
                modulesData = []; // fallback
            }
        }

        return modulesData;
    }



    // ------------------------------------------------main data get API start------------------------------------------------
    getallrealdata = () => {
        this.setState({
            loader: true,
        })
        let TokenValue = 'Token ' + localStorage.getItem("auth");
        var headers = {
            'Content-Type': 'application/json',
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken')
        }
        fetch('/we/addRoles/', {
            method: "GET",
            headers: headers
        })
            .then(response => response.json())
            .then(okasBoxData => {
                console.log(okasBoxData);
                this.setState({
                    okasBoxData,
                    actualdata: okasBoxData
                }, () => {
                    this.renderTableData();
                })
                this.setState({
                    loader: false,
                })
            })

    }
    //------------------------------------------------ main data get API end------------------------------------------------


    handleClickpage(number) {
        this.setState({
            currentPage: number,
        });
        this.renderTableData('type1');
        this.renderTableData('pagination');
    }
    //------------------------------------------------ print main data(List view) function start----------------------------
    renderTableData = (type) => {
        if (this.state.okasBoxData.detail == 'Invalid token.') {
            localStorage.removeItem('auth');
            localStorage.removeItem('username');
            this.props.history.push('/login')
        }
        let indexOfLastTodo = this.state.currentPage * this.state.todosPerPage;
        let indexOfFirstTodo = indexOfLastTodo - this.state.todosPerPage;
        let currentTodos = this.state.okasBoxData.slice(indexOfFirstTodo, indexOfLastTodo);
        if (type === 'pagination') {
            let pageNumbers = [];
            for (let i = 1; i <= Math.ceil(this.state.okasBoxData.length / this.state.todosPerPage); i++) {
                pageNumbers.push(i);
            }
            let renderPageNumbers = pageNumbers.map((number, i) => {
                if ((this.state.currentPage - 3 < i + 1) && ((this.state.currentPage + 3 > i + 1 || 6 > i + 1))) {
                    return (
                        <li className={this.state.currentPage == number ? "active" : null}><a id={number} onClick={this.handleClickpage.bind(this, number)}>{number}</a></li>
                    );
                }
            });
            return renderPageNumbers;
        }
        if (type === 'type1') {
            var typee = 0;
            let xx = currentTodos.map((e, index) => {
                typee = typee + 1;
                let offloc = e.ID;
                return (
                    <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{e.name.toUpperCase()}</td>
                        <td>{e.role_created_by}</td>
                        {is_allowed(
                            this.props.redux.permissions.permissions?.[0],
                            localStorage.getItem("name"),
                            "role",
                            "edit"
                        ) && (
                                <td className={this.props.windowWidth > 760 ? "qwerty" : ""}>
                                    <img
                                        src={Edit}
                                        onClick={() => {
                                            this.handleEditIcon(e)
                                        }}
                                        style={{ cursor: 'pointer' }}
                                    />
                                </td>

                            )}
                    </tr>
                )
            });
            return xx;
        }
    }
    //------------------------------------------------ print main data(List view) function end--------------------------------

    //------------------------------------------------ Delete Succ msg start//------------------------------------------------
    crosssuccessfullmsg = () => {
        localStorage.removeItem('dataadded');
        this.setState({
            successmsgmodaldata: '',
        })
    }

    crosserrorfullmsg = () => {
        localStorage.removeItem('dataadded');
        this.setState({
            error: '',
            nameerror: '',
        })
    }
    ////------------------------------------------------ Delete Succ msg end//------------------------------------------------

    oncolseClickHandler = (event) => {
        this.setState({
            name: '',
            selectedPermissions: {}
        })
    }
    // --------------------------------------------------------open model function start----------------------------
    onopenmodel = (event) => {
        this.setState({ name: "", selectedPermissions: {}, role_id: null })
        this.props.backgroundScrollStop(!this.props.redux.globalVar.backgroundScrollStop);
        this.setState({
            showmodels: 'true',
        })
        this.props.searchBarActivate(false)
        // this.getcitydata();
    }
    // --------------------------------------------------------open model function end----------------------------

    // --------------------------------------------------------close model function start----------------------------
    onclosemodel = (event) => {
        this.props.backgroundScrollStop(!this.props.redux.globalVar.backgroundScrollStop);
        this.setState({
            showmodels: '',
            error: '',
            name: '',
            selectedPermissions: {},
            nameerror: '',
        })
    }
    // --------------------------------------------------------close model function End----------------------------


    // ----------------------------Submit all data in data base POST API Start--------------------------------------

    // ----------------------------Submit all data in data base POST API Start--------------------------------------


    onAddClickHandler(type) {
        const { name, selectedPermissions } = this.state;

        if (!name.trim()) {
            this.setState({ error: "Please enter a group name" });
            return;
        }

        if (!selectedPermissions || Object.keys(selectedPermissions).length === 0) {
            this.setState({ error: "Please select at least one permission" });
            return;
        }

        const userEmail = localStorage.getItem("email"); // 👈 Make sure this is set during login

        const jsonData = {
            name,
            permissions: selectedPermissions,
            role_created_by: userEmail || "unknown",
        };


        // 🔥 POST request to we/addRoles/
        fetch(this.state.role_id ? `/we/addRoles_detail/${this.state.role_id}` : "/we/addRoles/", {
            method: this.state.role_id ? "PUT" : "POST",
            headers: {
                "Content-Type": "application/json",
                "X-CSRFToken": localStorage.getItem("csrftoken"),

            },
            body: JSON.stringify(jsonData),
        })
            .then(response => {
                if (response.status === 403) {
                    window.location = "/login/session-timeout"
                }
                return response.json()
            })
            .then((data) => {
                // console.log("✅ Group successfully added:", data);

                if (type === "add") {
                    this.setState({ name: "", selectedPermissions: {}, successmsgmodaldata: 'dataadded' });
                    this.onclosemodel();
                    this.getallrealdata();
                    this.errormsg();
                }

                // Optionally show a success message or toast
            })
            .catch((error) => {
                console.error("❌ Error adding role:", error);
            });
    }



    //----------------------------------------- Submit all data in data base POST API End----------------------------------------


    //-------------------------------------------Render data after sorting Function Start----------------------------------------------
    restoreData = (data) => {
        this.setState({
            okasBoxData: data,
        })
    }
    //-----------------------------------------------Render data after sorting Function End--------------------------------------------------


    //------------------------------------------------------- sorting Function Start----------------------------------------------
    sortingFunc = (type, searchValue) => {
        if (type !== "search") {
            this.props.searchBarActivate(false)
        }
        if (type == "geo_location") {
            this.setState({
                statuson: !this.state.statuson,
                statustw: false, statusth: false, statusfo: false,
                statusfi: false, statussi: false, statusse: false,
                statusei: false, statusni: false, statuste: false,
            })
        }
        if (type == "phone") {
            this.setState({
                statustw: !this.state.statustw,
                statuson: false, statusth: false, statusfo: false,
                statusfi: false, statussi: false, statusse: false,
                statusei: false, statusni: false, statuste: false,
            })
        }
        if (type == "email") {
            this.setState({
                statuson: false, statustw: false, statusth: false,
                statusfo: false, statusfi: false, statussi: false,
                statusse: false, statusei: false, statusni: false,
                statuste: false, statusth: !this.state.statusth,

            })
        }
        if (type == "location") {
            this.setState({
                statuson: false, statustw: false, statusth: false,
                statusfo: false, statusfi: false, statussi: false,
                statusse: false, statusei: false, statusni: false,
                statuste: false, statusfo: !this.state.statusfo,
            })
        }
        if (type == "installed_box") {
            this.setState({
                statuson: false, statustw: false, statusth: false,
                statusfo: false, statusfi: false, statussi: false,
                statusse: false, statusei: false, statusni: false,
                statuste: false, statusfi: !this.state.statusfi,
            })
        }
        if (this.state.sortedType !== type && type !== 'search') {
            this.setState({
                sortedType: type
            })
            Sorting(this.restoreData, type, this.state.okasBoxData);
        } else if (type === 'search') {
            type = 'search';
            Sorting(this.restoreData, type, this.state.actualdata, searchValue);
        } else {
            type = 'reverse';
            Sorting(this.restoreData, type, this.state.okasBoxData);
        }
    }

    //---------------------------------------------------------- sorting Function End--------------------------------------------------


    render() {
        return Style.it(`
        @media only screen and (max-width: 760px){
      td:nth-of-type(1):before { content: "S.NO"; }
      td:nth-of-type(2):before { content: "NAME"; }
      td:nth-of-type(3):before { content: "CREATED BY"; }
      td:nth-of-type(4):before { content: "EDIT"; }
    }`,
            <div className="selfcontainer"
                style={{
                    position: !this.props.redux.globalVar.backgroundScrollStop && this.props.windowWidth < 760 ? "fixed" : "absolute",
                    overflow: !this.props.redux.globalVar.backgroundScrollStop && this.props.windowWidth < 760 ? "hidden" : ""
                }}

            >
                <SnackBar open={this.state.snackbarActive} handleSnackbarClose={() => {
                    this.setState({
                        snackbarActive: false
                    })
                }} message={this.state.snackbarMessage} />
                {this.state.loader ? <Loader /> : null}
                {this.props.redux.globalVar.searchBarShow ?
                    <div className='row searchinput'>
                        <SearchBar
                            autoFocus
                            value={this.state.searchValue}
                            onChange={(e) => {
                                this.setState({
                                    searchValue: e
                                }, () => {
                                    this.sortingFunc('search', this.state.searchValue)
                                })
                            }
                            }
                            onRequestSearch={() => this.sortingFunc('search', this.state.searchValue)}
                            resetSearch={(e) => {
                                this.setState({
                                    searchValue: e
                                }, () => {
                                    this.sortingFunc('search', '')
                                })
                            }}
                        />
                    </div>
                    : ''}
                {/* <div className="searchbar"><a onClick={() => this.opensearch(this.state.opensearch1)}> <Icon icon={search} /></a></div> */}

                <div className="addregOkasButton">
                    {is_allowed(this.props.redux.permissions.permissions?.[0], localStorage.getItem("name"), "role", "add") && <Box
                        component="a"
                        // href="#regiokasbox"
                        className="addregOkasButtonicon button-custom-height-size"
                        onClick={this.onopenmodel.bind(this)}
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            backgroundColor: "#f9f9f9",
                            color: "#94979a",
                            textTransform: "none",
                            padding: "10px 20px",
                        }}
                    >
                        <AiOutlinePlus size={30} style={{ marginRight: 8, color: "#15599F" }} />
                        <span className="hidden-xs hidden-sm button-color">ADD NEW USER ROLE</span>
                    </Box>}
                    <div className="hidden-xs hidden-md  hidden-lg button-color sm-heading-btn">Add New User Role</div>
                </div>
                <div className="row">
                    <h3>Dear {this.props.redux.globalVar.reUserNameStyle}, Listed below are your existing user roles</h3>
                    <h6 className="mb-3 mt-0">To add a new user role click on, "Add New User Role" </h6>
                    <div className={this.state.successmsgmodaldata ? 'successmsgbox' : 'successmsgbox successmsgboxnone'}  >
                        <div className="inblksuccfull"><img src={Success} /></div>
                        <div className="inblksucc1">
                            SUCCESS !
                            <a className="successmsgcross"><RxCross2 style={{ color: 'white' }} size={20} onClick={this.crosserrorfullmsg} /></a>
                        </div>
                    </div>
                    <div className="tests">
                        <TableContainer component={Paper}>
                            <Table className={"tablecontent"}>
                                <TableHead>
                                    <TableRow>
                                        {[
                                            { label: "S.NO" },
                                            { key: "geo_location", label: "NAME" },
                                            { key: "phone", label: "CREATED BY" },
                                        ].map((column) => (
                                            <TableCell sx={{ width: this.props.windowWidth > 835 ? "20%" : "20%", color: "white", fontSize: '11px' }} key={column.key} >
                                                {column.label}
                                                <IconButton style={{ float: "right", cursor: "pointer", color: 'white' }} size="small" onClick={() => this.sortingFunc(column.key, "")}>
                                                    {this.state[`status${column.key}`] ? <IoIosArrowUp /> : <IoIosArrowDown />}
                                                </IconButton>
                                            </TableCell>
                                        ))}
                                        <TableCell sx={{ width: this.props.windowWidth > 835 ? "20%" : "20%", color: "white", fontSize: '11px' }}>EDIT</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.state.loader ? <Loader /> : this.renderTableData("type1")}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <div className="pull-right">
                            {this.state.todosPerPage < this.state.okasBoxData.length ?
                                <ul className="pagination pull-right paginat">
                                    <li>
                                        <span className="">Showing {(this.state.currentPage * this.state.todosPerPage) - this.state.todosPerPage + 1} -{this.state.currentPage * this.state.todosPerPage - this.state.okasBoxData.length < 0 ? this.state.currentPage * this.state.todosPerPage : this.state.okasBoxData.length}  of {this.state.okasBoxData.length} enteries</span>
                                    </li>
                                    <li>
                                        <a
                                            onClick={this.state.currentPage == -1 + this.state.currentPage * this.state.todosPerPage ? null :
                                                this.handleClickpage.bind(this, this.state.currentPage - 1)
                                            }
                                            aria-label="Previous">
                                            <span aria-hidden="true">&laquo;</span>
                                            <span className="sr-only">Previous</span>
                                        </a>
                                    </li>
                                    {this.renderTableData('pagination')}
                                    <li className="">
                                        <a className=""
                                            onClick={this.state.currentPage * this.state.todosPerPage == this.state.okasBoxData.length ? null :
                                                this.handleClickpage.bind(this, this.state.currentPage + 1)
                                            }
                                            aria-label="Next">
                                            <span aria-hidden="true">&raquo;</span>
                                            <span className="sr-only">Next</span>
                                        </a>
                                    </li>
                                </ul>
                                : null}
                        </div>
                    </div>
                </div>
                {this.state.showmodels ?
                    <div className="selfmodal fade in modal-dialog-centered" style={{ alignItems: "center", top: this.state.topHeightModal }} aria-hidden="false" data-backdrop="static" data-keyboard="false">
                        <div className="selfmodal-dialog"
                            style={{
                                width: this.props.windowWidth > 760 ? "50%" : "60%",
                            }}
                        >
                            <div className="selfmodal-content">
                                <div className="modal-header">
                                    <button type="button" className="close" data-dismiss="modal" onClick={this.onclosemodel.bind(this)}>&times;</button>
                                    <h3 className="modal-title">Add New User Role
                                    </h3>
                                    <h6>Please fill in the details to add new user role.</h6>
                                    <div className={this.state.error ? 'errormsgbox' : 'errormsgbox errormsgboxnone'}  >
                                        <div className="inblksucc"><img src={Error} /></div>
                                        <div className="inblksucc1">
                                            {this.state.error} !
                                            <a className="successmsgcross"><RxCross2 size={20} onClick={(e) => { this.crosserrorfullmsg(this) }} /></a>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-body modfields">

                                    <TextField
                                        label="Group Name"
                                        type="text"
                                        name="name"
                                        id="name"
                                        fullWidth
                                        variant="standard"
                                        required
                                        value={this.state.name}
                                        onChange={(e) => {
                                            const input = e.target.value;
                                            const validInput = input.replace(/[^a-zA-Z ]/g, '').slice(0, 25); // Only letters & space, max 25 chars
                                            this.setState({ name: validInput, addresserror: false });
                                        }}
                                    
                                        onPaste={(e) => {
                                            const pastedData = e.clipboardData.getData('text');
                                            if (!/^[a-zA-Z ]+$/.test(pastedData)) {
                                                e.preventDefault(); // prevent pasting invalid characters
                                            }
                                        }}
                                        error={this.state.name === '' && this.state.addresserror}
                                        helperText={
                                            this.state.name === '' && this.state.addresserror
                                                ? "Only letters allowed (max 25 characters)"
                                                : `${this.state.name.length}/25`
                                        }
                                        style={{ marginBottom: "10px" }}
                                    />

                                    <div style={{ maxHeight: '40vh', overflow: 'auto' }}>
                                        <DynamicAccordion initial_permissions={this.state.selectedPermissions} modulesData={this.getPermissions()} onChange={(selectedPermissions) => { this.setState({ selectedPermissions }) }} />
                                    </div>
                                    <span className="fieldmend"></span>
                                </div>

                                <div className="modal-footer align-btn-mobile" style={{ marginTop: '6%', display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                                    <div type="button" className="btn allbtn" onClick={this.onclosemodel.bind(this)}>Cancel</div>
                                    <div type="submit" disabled={this.state.disabledvalue ? this.state.disabledvalue : null} className="btn allbtn" style={{ backgroundColor: '#4286f5' }} onClick={this.onAddClickHandler.bind(this, 'add')}>Request</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    : ''}
                {this.state.confirmWindow ? <div className="selfmodal fade in modal-dialog-centered" aria-hidden="false" data-backdrop="static" data-keyboard="false">
                    <div className="selfmodal-dialog " style={{ width: "50%" }}>
                        <div className="selfmodal-content ">
                            <div className="modal-header">
                                <button type="button" className="close" data-dismiss="modal" onClick={this.confirmWindowClose.bind(this)}>&times;</button>
                                <h4 className="modal-title h3 text-center">Delete confirmation</h4>
                            </div>
                            <div className="modal-body modfields">
                                <span className="fa " >Delete icon</span>
                            </div>
                            <div className="modal-footer text-center  align-btn-mobile">
                                <button type="button" className="btn allbtn" onClick={this.confirmWindowClose.bind(this)}>Cancel</button>
                                {/* <button type="submit" disabled={this.state.disabledvalue ? this.state.disabledvalue : null} className="btn btn-primary allbtn" onClick={this.ondeleteChangekHandler.bind(this)}>Delete</button> */}
                            </div>
                        </div>
                    </div>
                </div> : null}
            </div>
        );
    }
}


const mapStateToProps = state => {
    return {
        redux: state,
    };
};


const mapDispatchToProps = dispatch => {
    return {
        searchBarActivate: (data) => dispatch({ type: ActionTypes.SEARCHBAR, data: data }),
        searchBarStyleActivate: (data) => dispatch({ type: ActionTypes.SEARCHBARSTYLE, data: data }),
        successBarActivate: (data) => dispatch({ type: ActionTypes.SUCCESSBAR, data: data }),
        backgroundScrollStop: (data) => dispatch({ type: ActionTypes.SCROLLSTOP, data: data }),
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(Roles);
